import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui' // 引入 Element UI
import 'element-ui/lib/theme-chalk/index.css' // 引入 Element UI 样式
import '@/assets/css/index.scss'

router.afterEach((to) => {
  // 如果路由 meta 有 title，就用它
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '默认标题'
  }
})


Vue.config.productionTip = false
Vue.use(ElementUI) // 使用 Element UI
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
